const walker = (id, node) => {
  if (node.id === id) {
    return node
  } else {
    let result

    node.children.forEach((child) => {
      if (!result) {
        result = walker(id, child)
      }
    })

    return result
  }
}

const makeTree = function (nodes, links) {
  const tree = {
    ...nodes[0],
    children: []
  }

  nodes.slice(1, Infinity).forEach((current, i) => {
    const linksToCurrent = links.filter((d) => d.target === current.id)
    linksToCurrent.forEach((link) => {
      const parentRef = walker(link.source, tree)
      if (parentRef) {
        parentRef.children.push({
          ...current,
          children: []
        })
      }
    })
  })

  return tree
}

const dictFromTree = (
  tree,
  idAccessor = (d) => d.data.id
) => {
  const dict = {}
  const getChildren = (nodes) => {
    return nodes.forEach(node => {
      dict[idAccessor(node)] = node

      if (node.children) {
        getChildren(node.children)
      }
    })
  }
  getChildren([tree])

  return dict
}

export {
  makeTree,
  dictFromTree
}
